module.exports = __webpack_public_path__ + "static/media/_GPX0940.ec8e263d.jpeg";